import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'primary-teacher-warning-dialog',
  templateUrl: './primary-teacher-warning-dialog.component.html'
})
export class PrimaryTeacherWarningDialogComponent {

  constructor( private dialogRef: MatDialogRef<PrimaryTeacherWarningDialogComponent> ) {
  }

  ngOnInit() {

  }

  okClick(){
    this.dialogRef.close('OK was clicked');
  }

  closeClick(){
    this.dialogRef.close('Close was clicked.');
  }

}
